import { useContext, useEffect, useState } from 'react'
import { Card, Icon, Table } from '../../gsys-ui'
import haxios from '../../lib/haxios'
import useApi from '../../hooks/useApi'
import moment from 'moment'
import { PencilIcon, TrashIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useForm } from 'react-hook-form'
import { Checkbox, NativeSelect, TextInput, Button, ActionIcon, Textarea, Group, Radio, Chip } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { modals } from '@mantine/modals'
import { errorToast, successToast } from '../../lib/helpers'
import { GiPalmTree } from 'react-icons/gi'
import { GlobalContext } from '../../context/GlobalContext'
import { ClockIcon } from 'lucide-react'
import BranchDropdown from '../../components/BranchDropdown'
import MultiButton from '../../gsys-ui/MultiButton/MultiButton'

const Holidays = () => {
  const [branch, setBranch] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(moment().month() + 1)
  const [selectedYear, setSelectedYear] = useState(moment().year())
  const [status, setStatus] = useState('PENDING')
  const { uinfo } = useContext(GlobalContext)

  const {
    data: holidayRequests,
    isLoading,
    refetch
  } = useApi({
    url: '/salesassist/cplusassist/holidayrequests'
  })

  const {
    data: staffData,
    isLoading: isStaffLoading,
    refetch: refetchStaff
  } = useApi({
    url: '/salesassistnew/ustafferators'
  })

  if (isLoading || isStaffLoading) return null

  const dataJoined = holidayRequests.map((req) => {
    const staff = staffData.filter((s) => s.StaffId === req.staffId).pop()
    console.log('staff', staff)

    return {
      ...req,
      StaffName: `${staff.FName} ${staff.SName}`,
      Position: staff.Position,
      Branch: staff.Branch
    }
  })

  const dataFiltered = dataJoined.filter((req) => {
    const requestDate = moment(req.dtStart)
    const isInDate = requestDate.month() + 1 === selectedMonth && requestDate.year() === selectedYear
    const isStatus = status === 'ALL' || req.decision.toLowerCase() === status.toLowerCase()
    const isBranch = branch === 'ALL' || req.Branch === branch
    console.log(req)
    return isInDate && isStatus && isBranch
  })

  return (
    <Card>
      <Card.Title>
        <div className="flex items-center space-x-2">
          <Icon Comp={GiPalmTree} />
          <div>Holiday requests</div>
        </div>

        <div className="flex items-center space-x-2 font-normal">
          <MultiButton
            value={status}
            options={[
              { label: 'Pending', value: 'PENDING' },
              { label: 'Accepted', value: 'ACCEPTED' },
              { label: 'Rejected', value: 'REJECTED' },
              { label: 'All', value: 'ALL' }
            ]}
            onChange={setStatus}
          />
          <BranchDropdown branch={branch} setBranch={setBranch} />
          <NativeSelect
            value={selectedMonth}
            onChange={(e) => setSelectedMonth(parseInt(e.currentTarget.value))}
            data={[
              { value: 1, label: 'January' },
              { value: 2, label: 'February' },
              { value: 3, label: 'March' },
              { value: 4, label: 'April' },
              { value: 5, label: 'May' },
              { value: 6, label: 'June' },
              { value: 7, label: 'July' },
              { value: 8, label: 'August' },
              { value: 9, label: 'September' },
              { value: 10, label: 'October' },
              { value: 11, label: 'November' },
              { value: 12, label: 'December' }
            ]}
          />
          <NativeSelect
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.currentTarget.value))}
            data={Array.from({ length: 2024 - moment().year() + 2 }, (_, i) => 2024 + i).map((num) => ({
              value: num,
              label: num
            }))}
          />
        </div>
      </Card.Title>
      <Table
        data={dataFiltered}
        columns={[
          {
            header: 'Staff',
            accessorKey: 'StaffName'
          },
          {
            header: 'Position',
            accessorKey: 'Position'
          },
          {
            header: 'Branch',
            accessorKey: 'Branch'
          },
          {
            header: 'Holiday allocation'
          },
          {
            header: 'Request date',
            id: 'reqDate',
            cell: ({ row }) => moment(row.original.requestDate).format('DD/MM/YYYY')
          },
          {
            header: 'Start date',
            id: 'start',
            cell: ({ row }) => moment(row.original.dtStart).format('DD/MM/YYYY')
          },
          {
            header: 'End date',
            id: 'end',
            cell: ({ row }) => moment(row.original.dtEnd).format('DD/MM/YYYY')
          },
          {
            header: 'Days',
            id: 'days',
            cell: ({ row }) => moment(row.original.dtEnd).diff(moment(row.original.dtStart), 'days') + 1
          },
          {
            header: 'Status',
            id: 'status',
            cell: ({ row }) =>
              row.original.decision === 'APPROVED' ? (
                <Chip color="green" checked={true} size="md">
                  Approved
                </Chip>
              ) : row.original.decision === 'REJECTED' ? (
                <Chip color="red" checked={true} icon={<Icon Comp={XMarkIcon} size={4} />} size="md">
                  Rejected
                </Chip>
              ) : (
                <Chip color="orange" checked={true} icon={<Icon Comp={ClockIcon} size={4} />} size="md">
                  Pending
                </Chip>
              )
          },
          {
            header: 'Notes',
            accessorKey: 'Notes'
          },
          {
            header: '',
            id: 'edit',
            width: 1,
            cell: ({ row }) =>
              row.original.decision === 'PENDING' ? (
                <Actions row={row.original} refetch={refetch} uinfo={uinfo} requests={holidayRequests} />
              ) : null
          }
        ]}
      />
    </Card>
  )
}

const Actions = ({ row, refetch, requests }) => {
  const handleReviewRequest = () => {
    modals.openContextModal({
      modal: 'holidayReviewModal',
      centered: true,
      withCloseButton: false,
      padding: 0,
      size: '900px',
      innerProps: {
        thisReq: row,
        requests: requests,
        refetch
      }
    })
  }

  return (
    <div className="flex space-x-1">
      <Button onClick={handleReviewRequest}>Review</Button>
    </div>
  )
}

export const HolidayEditModal = ({ context, id, innerProps }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const onSubmit = (data) => console.log(data)

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <NativeSelect label="Staff member" {...register('StaffID')} />
        <Checkbox label="Paid" />
        <TextInput label="Paid hours per day" {...register('HoursPerDay')} />
        <div className="font-bold">Total hours to be paid: todo</div>
        <Textarea label="Reason" {...register('Reason')} />
        <DateInput label="Start date" {...register('StartDateTime')} />
        <DateInput label="End date (inclusive)" {...register('EndDateTime')} />
        <Group>
          <Radio label="All day" />
          <Radio label="AM" />
          <Radio label="PM" />
        </Group>
        <Button>Submit</Button>
      </form>
    </>
  )
}

export default Holidays
